export const appVersion = process.env.GATSBY_APP_VERSION || 'development'

export const routes = {
  top: '/',
  login: '/login/stores',
  home: '/admin',
  analysis: '/admin/analysis',
  analysisSchedule: '/admin/analysis/schedule',
  analysisReport: '/admin/analysis/report',
  bookings: '/admin/bookings',
  bookingsBulk: '/admin/bookings/bulk',
  customers: '/admin/customers',
  customersPersonal: '/admin/customers/personal',
  customersCorporate: '/admin/customers/corporate',
  customersUnRegister: '/admin/customers/unregister',
  discounts: '/admin/discounts',
  notifications: '/admin/notifications',
  products: '/admin/products',
  rates: '/admin/rates',
  settings: '/admin/settings',
  settingsAccounts: '/admin/settings/accounts',
  settingsGeneral: '/admin/settings/general',
  settingsArena: '/admin/settings/arena',
  settingsHolidays: '/admin/settings/holidays',
  ledgers: '/admin/ledgers',
  ledgerItems: '/admin/ledgers/items',
  ledgerItemsNew: '/admin/ledgers/items/new',
}

export const product = {
  maxPrice: 99_999_999,
  maxInventory: 1000,
}

export const api = {
  admin: process.env.GATSBY_API_URL_ADMIN,
  storeadmin: process.env.GATSBY_API_URL_STOREADMIN,
  observer: process.env.GATSBY_API_URL_OBSERVER,
}

export const auth0 = {
  domain: process.env.GATSBY_AUTH0_DOMAIN,
  clientId: process.env.GATSBY_AUTH0_CLIENTID,
  callback: process.env.GATSBY_AUTH0_CALLBACK,
  audience: process.env.GATSBY_AUTH0_AUDIENCE,
  organizations: [
    {
      id: process.env.GATSBY_AUTH0_ORGANIZATION_ID_SAGA_AQUA,
      name: 'saga-aqua',
      displayName: 'SAGAアクア',
    },
    {
      id: process.env.GATSBY_AUTH0_ORGANIZATION_ID_SAGA_PLAZA,
      name: 'saga-plaza',
      displayName: 'SAGAプラザ',
    },
    {
      id: process.env.GATSBY_AUTH0_ORGANIZATION_ID_SAGA_STA,
      name: 'saga-sta',
      displayName: 'SAGAスタ等屋外施設',
    },
    {
      id: process.env.GATSBY_AUTH0_ORGANIZATION_ID_SAGA_ARENA,
      name: 'saga-arena',
      displayName: 'SAGAアリーナ',
    },
  ],
  observers: [
    {
      id: process.env.GATSBY_AUTH0_ORGANIZATION_ID_SAGA_OBSERVER,
      name: 'saga-observer',
      displayName: 'アリーナ年間予約状況',
    },
  ],
}

export enum SAGA_ARENA_PRODUCT_NAME {
  MAIN_ARENA = 'メインアリーナ',
  SUB_ARENA = 'サブアリーナ',
  OTHER = 'その他',
}

export enum SAGA_ARENA_USAGE_TYPE {
  EVENT = '催事',
  SETUP_TEARDOWN = '設営・撤去',
  EXTENSION = '延長',
  NO_PERFORMANCE = '休演',
}

export enum SAGA_ARENA_PROFIT_TYPE {
  FOR_PROFIT = '営利',
  NON_PROFIT = '非営利',
}

export enum SUB_ARENA_PROFIT_TYPE {
  FOR_PROFIT = '【営利】',
  NON_PROFIT = '【非営利】',
}

export const SUB_ARENA_BOOKING_TIMEZONE = {
  MORNING: {
    NAME: '午前',
    START: '09:00',
    END: '12:00',
  },
  AFTERNOON: {
    NAME: '午後',
    START: '12:00',
    END: '17:00',
  },
  NIGHT: {
    NAME: '夜間',
    START: '17:00',
    END: '22:00',
  },
  ALLDAY_08: {
    NAME: '12時間',
    START: '08:00',
    END: '20:00',
  },
  ALLDAY_09: {
    NAME: '12時間',
    START: '09:00',
    END: '21:00',
  },
  ALLDAY_10: {
    NAME: '12時間',
    START: '10:00',
    END: '22:00',
  },
}

const config = {
  appVersion,
  routes,
  product,
  api,
  auth0,
}

export default config
